import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import SEO from "@/components/public/SEO";
import { Check, Mail, MapPin } from "lucide-react";

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "", consent: true });
  const [state, setState] = useState({ loading: false, ok: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, ok: false, error: "" });
    try {
      await api.post("/leads/contact", { ...form, language: "tr" });
      setState({ loading: false, ok: true, error: "" });
      setForm({ name: "", email: "", phone: "", subject: "", message: "", consent: true });
    } catch (err) {
      setState({ loading: false, ok: false, error: formatApiError(err.response?.data?.detail) || err.message });
    }
  };

  return (
    <>
      <SEO title="İletişim" description="Capella Cave ile iletişime geçin. Sorularınız, işbirlikleri ve basın talepleri için." />
      <section className="pt-40 pb-16 max-w-5xl mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">İletişim</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-none mb-8">Bize yazın.</h1>
        <p className="text-cc-muted max-w-xl text-lg leading-relaxed">
          İşbirlikleri, basın talepleri, açılış öncesi sorularınız ya da yalnızca selam vermek için —
          okuyoruz, yanıtlıyoruz.
        </p>
      </section>

      <section className="pb-32 max-w-5xl mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5 space-y-8">
          <div>
            <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-2">E-posta</div>
            <p className="text-cc-text flex items-center gap-2"><Mail size={16} className="text-cc-sepia" /> merhaba@capellacave.com</p>
          </div>
          <div>
            <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-2">Adres</div>
            <p className="text-cc-text flex items-start gap-2"><MapPin size={16} className="text-cc-sepia mt-1" /> Göreme, Nevşehir,<br/>Kapadokya / Türkiye</p>
          </div>
          <div>
            <div className="text-[10px] tracking-overline uppercase text-cc-sepia mb-2">Basın</div>
            <p className="text-cc-text">press@capellacave.com</p>
          </div>
        </div>

        <div className="md:col-span-7">
          {state.ok ? (
            <div className="text-center py-16 border border-cc-border" data-testid="contact-ok">
              <Check size={32} className="mx-auto text-cc-sepia mb-4" />
              <h3 className="font-serif text-2xl mb-2">Mesajınız alındı.</h3>
              <p className="text-cc-muted text-sm">En kısa sürede dönüş yapacağız.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-7" data-testid="contact-form">
              <div className="grid md:grid-cols-2 gap-6">
                <div><label className="text-[10px] tracking-overline uppercase text-cc-muted">Ad Soyad</label>
                  <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="cc-input" placeholder="Adınız" /></div>
                <div><label className="text-[10px] tracking-overline uppercase text-cc-muted">E-posta</label>
                  <input data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="cc-input" placeholder="eposta@adres.com" /></div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div><label className="text-[10px] tracking-overline uppercase text-cc-muted">Telefon</label>
                  <input data-testid="contact-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="cc-input" placeholder="+90" /></div>
                <div><label className="text-[10px] tracking-overline uppercase text-cc-muted">Konu</label>
                  <input data-testid="contact-subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="cc-input" placeholder="Konu" /></div>
              </div>
              <div><label className="text-[10px] tracking-overline uppercase text-cc-muted">Mesajınız</label>
                <textarea data-testid="contact-message" required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="cc-input min-h-[140px]" placeholder="Yazın..."></textarea></div>
              <label className="flex items-start gap-3 text-xs text-cc-muted"><input data-testid="contact-consent" type="checkbox" checked={form.consent} onChange={(e) => setForm({ ...form, consent: e.target.checked })} className="mt-1" /> KVKK kapsamında verilerimin işlenmesini onaylıyorum.</label>
              <button type="submit" disabled={state.loading || !form.consent} className="cc-btn" data-testid="contact-submit">
                {state.loading ? "Gönderiliyor…" : "Mesajı Gönder"}
              </button>
              {state.error && <p className="text-sm text-red-600">{state.error}</p>}
            </form>
          )}
        </div>
      </section>
    </>
  );
}
